
export type BsbComponentValue = string | null;
